import { SystemAnnouncementCategory } from '~/models/system-announcement';

/** Vuetify chip/color for a system announcement category. */
export function systemAnnouncementCategoryColor(category: SystemAnnouncementCategory | string): string {
  switch (category) {
    case SystemAnnouncementCategory.RELEASE_NOTE:
      return 'warning';
    case SystemAnnouncementCategory.GUIDELINE:
      return 'info';
    case SystemAnnouncementCategory.ANNOUNCEMENT:
    default:
      return 'success';
  }
}
